// telephone replaces the telephone component from react-components-web / components-core

const formatTen = (area: string, first: string, last: string) => {
  if (last) {
    return '(' + area + ') ' + first + ' - ' + last
  } else if (first) {
    return '(' + area + ') ' + first
  }
  return area
}

const divide = (tele: string) => {
  return {
    area: tele.substring(0, 3),
    first: tele.substring(3, 6),
    last: tele.substring(6),
  }
}

export const format = (input: string | undefined) => {
  if (input !== undefined) {
    let tele = unformat(input)
    if (tele === undefined) {
      return ''
    }
    if (tele.length > 10) {
      const country = tele.substring(0, tele.length - 10)
      tele = tele.substring(country.length)

      const { area, first, last } = divide(tele)
      return country + ' ' + formatTen(area, first, last)
    }

    const { area, first, last } = divide(tele)
    return formatTen(area, first, last)
  }
  return ''
}

export const unformat = (input: string | undefined) => {
  if (input === undefined) {
    return undefined
  }
  return input.replace(/[^0-9]/g, '')
}

export default {
  format,
  unformat,
}
